import { useQuery } from '@tanstack/react-query';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

export interface BatchRequestItem {
  _id: string;
  requestId: string;
  timestamp: Date;
  endpoint: string;
  method: string;
  status?: number;
}

export interface BatchRequestsResponse {
  batch: {
    _id: string;
    name: string;
    counter: number;
  };
  requests: BatchRequestItem[];
}

export const useBatchRequests = (search: string, enabled = false) => {
  return useQuery({
    queryKey: ['batch-requests', search],
    queryFn: async (): Promise<BatchRequestsResponse | null> => {
      try {
        const queryParams = new URLSearchParams({
          search,
        });

        return await request({
          path: `admin/requests/batch?${queryParams.toString()}`,
          method: 'GET',
          authenticate: true,
        });
      } catch (error) {
        showErrorToast(error, 'Failed to fetch batch requests');
        return null;
      }
    },
    enabled: enabled && search.length > 0,
  });
};
